<template>
  <div>
    <div ref="index" class="row mb-2">
      <div class="col-md-6">
        <input v-model="query.generic" class="input form-control"
               @keypress.enter="$emit('find')"
               placeholder="Pesquisar por Razão Social ou CNPJ">
        <search-icon @click="$emit('find')" class="icon icon-within"/>
      </div>

      <div v-if="$withPolicy('application', 'companies/insert_or_update')" class="col-md-6">
        <button @click="$emit('createCompany')" class="btn btn-primary mr-2">
          Cadastrar fornecedor
        </button>

        <button class="btn btn-primary float-right" @click="showModalUpload = true">
          Upload arquivo modelo
        </button>

        <button class="btn btn-primary mr-2 float-right" @click="downloadTemplate">
          Download arquivo modelo
        </button>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <Table
          :companies="companies"
          @showCompany="$emit('showCompany', $event)"
          @sendDeleteCompany="$emit('sendDeleteCompany', $event)"
        />

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="$emit('pagination', $event)"
            />
          </div>
        </div>

      </div>
    </div>

    <Modal v-model="showModalUpload">
      <Upload :isMultiple="false" accept=".csv, .CSV" @changeFiles="changeFiles">
        <h5>Clique para selecionar ou arraste o arquivo CSV</h5>
      </Upload>
    </Modal>

  </div>
</template>

<script>
import Pagination from '@/components/shares/specialTag/Pagination'
import Modal from '@/components/shares/specialTag/Modal'
import Table from '@/components/providers/container/Table'
import Upload from '@/components/shares/specialTag/Upload'
import {SearchIcon} from 'vue-feather-icons'

export default {
    components: { Modal, Pagination, SearchIcon, Table, Upload },
    data() {
      return {
        showModalUpload: false
      }
    },
    methods: {
      changeFiles(files) {
        this.$emit('uploadFile', files[0])
        this.showModalUpload = false
      },
      downloadTemplate() {
        window.location.href = this.linkDownloadTemplate();
      },
      linkDownloadTemplate() {
        return `${process.env.VUE_APP_ROOT_API_URL}/companies/template_file/provider`
      }
    },
    name: 'Index',
    props: {
      companies: { required: true, type: Array },
      meta: { required: true, type: Object },
      query: { required: true, type: Object }
    }
  }
</script>

<style scoped>

</style>